export interface ChangePasswordToken {
  forgot_token: string;
  password_new: string;
  password_confirm: string;
}
